import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  role?: string;
  requiredRole?: string;
  requireMsal?: boolean; // Set to true for staff routes, false for student routes
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  role,
  requiredRole,
  requireMsal = false, // Default to false (student routes)
}) => {
  const { isAuthenticated: contextAuth, isLoading } = useAuth();

  const navigate = useNavigate();

  // ✅ Check both context AND localStorage as fallback
  const localStorageToken = localStorage.getItem('authToken');
  const isLocallyAuthenticated = contextAuth || !!localStorageToken;

  useEffect(() => {


    // Student route check
    if (!requireMsal && !isLocallyAuthenticated) {
      console.log('[PROTECTED_ROUTE] No local token for student route - redirecting to /login');
      navigate('/login', { replace: true });
      return;
    }
  }, [isLoading, contextAuth, navigate, localStorageToken, isLocallyAuthenticated]);


  return <>{children}</>;
};

export default ProtectedRoute;